class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    
    // Listen for slide changes in the Glide slider
    document.addEventListener('glide.slide.changed', () => {
      this.updateVariantLabelPosition();
    });
  }
  
  updateVariantLabelPosition() {
    const variantLabel = document.getElementById('variant-label');
    const activeSlide = document.querySelector('.glide__slide.glide__slide--active');
    
    if (variantLabel && activeSlide) {
      const mediaContainer = activeSlide.querySelector('.product__media');
      if (mediaContainer && !mediaContainer.contains(variantLabel)) {
        // Remove existing label from any slide
        document.querySelectorAll('.product__media #variant-label').forEach(el => el.remove());
        // Add label to the active slide
        mediaContainer.insertAdjacentElement('afterbegin', variantLabel);
      }
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
    // Always move #variant-label inside .card__badge after variant change
    const badgeContainer = document.querySelector('.card__badge');
    const variantLabel = document.getElementById('variant-label');
    if (badgeContainer && variantLabel) {
      badgeContainer.appendChild(variantLabel); // Always move, no harm if already child
      // Update label text and attributes
      if (this.currentVariant && this.currentVariant.metafields && this.currentVariant.metafields.algemeen_variants) {
        const variantMeta = this.currentVariant.metafields.algemeen_variants;
        variantLabel.textContent = variantMeta.label_variant_productkaart || '';
        variantLabel.setAttribute('data-bg', variantMeta.label_background_color || '');
        variantLabel.setAttribute('data-text', variantMeta.label_text_color || '');
        variantLabel.style.display = variantMeta.label_variant_productkaart ? '' : 'none';
      } else {
        variantLabel.style.display = 'none';
      }
      // Debug: log parent
      console.log('variantLabel parent:', variantLabel.parentNode, 'should be .card__badge:', badgeContainer);
    }
  }

  updateOptions() {
    // Collect all <select> values and checked radios, in DOM order
    const optionElements = Array.from(this.querySelectorAll('select, input[type="radio"]'));
    const options = [];
    const names = [];
    optionElements.forEach(el => {
      if (el.tagName === 'SELECT') {
        options.push(el.value);
        names.push(el.name);
      } else if (el.checked && !names.includes(el.name)) {
        options.push(el.value);
        names.push(el.name);
      }
    });
    this.options = options;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const sliderContainer = document.querySelector(`[data-slider-container]`);
    if (!sliderContainer) return;
    
    // Move variant label to the active slide
    const activeSlide = document.querySelector('.glide__slide.glide__slide--active');
    const variantLabel = document.getElementById('variant-label');
    if (activeSlide && variantLabel) {
      const mediaContainer = activeSlide.querySelector('.product__media');
      if (mediaContainer && !mediaContainer.contains(variantLabel)) {
        mediaContainer.insertAdjacentElement('afterbegin', variantLabel);
      }
    }

    // --- Overlay logic for thumbnails ---
    const thumbnailsContainer = document.querySelector('.image-thumbnails');
    if (thumbnailsContainer) {
      const firstThumbDiv = thumbnailsContainer.querySelector('div');
      if (firstThumbDiv) {
        let overlayImg = firstThumbDiv.querySelector('.variant-thumb-overlay');
        const firstThumbImg = firstThumbDiv.querySelector('img');
        const variantImgSrc = this.currentVariant.featured_media.preview_image.src;
          // Only overlay if the variant image is not already the first image
          if (firstThumbImg && firstThumbImg.src !== variantImgSrc) {
            if (!overlayImg) {
              overlayImg = document.createElement('img');
              overlayImg.className = 'variant-thumb-overlay';
              overlayImg.style.position = 'absolute';
              overlayImg.style.top = '0';
              overlayImg.style.left = '0';
              overlayImg.style.width = '100%';
              overlayImg.style.height = '100%';
              overlayImg.style.objectFit = 'cover';
              overlayImg.style.zIndex = '1';
              overlayImg.style.cursor = 'pointer';
              overlayImg.tabIndex = 0;
              overlayImg.setAttribute('role', 'button');
              overlayImg.setAttribute('aria-label', 'Toon variant afbeelding');
              firstThumbDiv.style.position = 'relative';
              firstThumbDiv.appendChild(overlayImg);
            }
            overlayImg.src = variantImgSrc;
            overlayImg.alt = this.currentVariant.featured_media.alt || '';
            overlayImg.title = 'Toon variant afbeelding';
            overlayImg.style.display = '';
            overlayImg.style.pointerEvents = 'auto';
  
            // Remove previous click event to prevent duplicates
            overlayImg.onclick = null;
            overlayImg.onkeydown = null;
  
            overlayImg.onclick = (e) => {
              e.preventDefault();
              // Find the corresponding slide in the slider and scroll to it
              const sliderContainer = document.querySelector('[data-slider-container]');
              if (!sliderContainer) return;
              const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
              const targetLi = sliderContainer.querySelector(`[data-media-id="${mediaId}"]`);
              if (targetLi) {
                this.scrollToMedia(targetLi, sliderContainer);
              }
            };
            overlayImg.onkeydown = (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                overlayImg.onclick(e);
              }
            };
          } else if (overlayImg) {
            overlayImg.style.display = 'none';
            overlayImg.style.pointerEvents = 'none';
            overlayImg.onclick = null;
            overlayImg.onkeydown = null;
          }
        }
      }

  const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
  let newMedia = sliderContainer.querySelector(`[data-media-id="${mediaId}"]`);

  // If the variant image isn't already in the slider, dynamically add it
  if (!newMedia) {
    const variantImageSrc = this.currentVariant.featured_media.preview_image.src;

    // Preload the image before appending it
    const image = new Image();
    image.src = variantImageSrc;

    image.onload = () => {
      // Create the new `li` element
      newMedia = document.createElement('li');
      newMedia.classList.add('product__media-item', 'glide__slide');
      newMedia.setAttribute('data-media-id', mediaId);
      newMedia.setAttribute('data-variant-image', 'true'); // Mark it for cleanup later if needed

      newMedia.innerHTML = `
        <div class="product__media media" style="padding-top: 75%; aspect-ratio: 4/3;">
          <img
            src="${variantImageSrc}"
            alt="${this.currentVariant.featured_media.alt || ''}"
            loading="lazy"
            width="920"
            height="920"
          >
        </div>
      `;

      // Append the preloaded `li` to the slider container
      sliderContainer.appendChild(newMedia);

      // Scroll to the new `li` after appending
      this.scrollToMedia(newMedia, sliderContainer);
    };

    image.onerror = () => {
      console.error(`Failed to preload image: ${variantImageSrc}`);
    };

    return; // Exit here to wait for the image to load before scrolling
  }

  // Scroll to the existing `li`
  this.scrollToMedia(newMedia, sliderContainer);
}

// Helper function to scroll to the media item
scrollToMedia(targetLi, sliderContainer) {
  if (!targetLi || !sliderContainer) return;

  // Scroll logic
  const offsetLeft = targetLi.offsetLeft;
  sliderContainer.style.transform = `translate3d(-${offsetLeft}px, 0px, 0px)`;

  // Remove active class from all slides
  const allSlides = sliderContainer.querySelectorAll('.glide__slide');
  allSlides.forEach(slide => slide.classList.remove('glide__slide--active'));
  targetLi.classList.add('glide__slide--active');

  // Find the index of the target slide
  const slideIndex = Array.from(allSlides).indexOf(targetLi);

  // Dispatch custom event with the new index
  const variantChangeEvent = new CustomEvent('variantImageChange', {
    detail: { slideIndex: slideIndex }
  });
  document.dispatchEvent(variantChangeEvent);
}


  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }


  updateVariantLabel(html) {
    const variantLabelDestination = document.getElementById('variant-label');
    const variantLabelSource = html.getElementById('variant-label');
    const badgeContainer = document.querySelector('.card__badge');

    // Remove any existing variant label from the DOM
    document.querySelectorAll('#variant-label').forEach(el => el.remove());

    // If we have a new label from AJAX and a badge container, add it there
    if (variantLabelSource && badgeContainer) {
      const newLabel = variantLabelSource.cloneNode(true);
      badgeContainer.appendChild(newLabel);
      if (typeof applyVariantBadgeStyles === 'function') applyVariantBadgeStyles();
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        // Update delivery time block
        const deliveryId = `delivery-time-${this.dataset.section}`;
        const deliveryDestination = document.getElementById(deliveryId);
        const deliverySource = html.getElementById(deliveryId);
        if (deliverySource && deliveryDestination) {
          deliveryDestination.innerHTML = deliverySource.innerHTML;
        }
        
        // Update variant label
        this.updateVariantLabel(html);
        
        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

function updateSelectedColorNames() {
  // For each color swatch fieldset
  document.querySelectorAll('fieldset[data-color-fieldset]').forEach(fieldset => {
    const selectedRadio = fieldset.querySelector('input[type="radio"]:checked');
    const colorNameSpan = fieldset.querySelector('.selected-color-name');
    if (selectedRadio && colorNameSpan) {
      colorNameSpan.textContent = selectedRadio.value;
    }
  });
}

function setupColorNameListeners() {
  document.querySelectorAll('fieldset[data-color-fieldset]').forEach(fieldset => {
    fieldset.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => {
        updateSelectedColorNames();
      });
    });
  });
}

function setupShowMoreSwatches() {
  document.querySelectorAll('.show-more-swatches').forEach(button => {
    button.addEventListener('click', function() {
      const key = button.getAttribute('data-show-more-for');
      const hidden = document.querySelector('[data-hidden-swatches-for="' + key + '"]');
      if (hidden) {
        hidden.style.display = '';
        button.style.display = 'none';
      }
    });
  });
}

function applyVariantBadgeStyles() {
  document.querySelectorAll('.variant-badge').forEach(function(badge) {
    var bg = badge.getAttribute('data-bg');
    var text = badge.getAttribute('data-text');
    if (bg) {
      badge.style.backgroundColor = bg;
      badge.style.borderColor = bg;
    }
    if (text) {
      badge.style.color = text;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  updateSelectedColorNames();
  setupColorNameListeners();
  setupShowMoreSwatches();
  applyVariantBadgeStyles();
});
document.addEventListener('shopify:section:load', () => {
  updateSelectedColorNames();
  setupColorNameListeners();
  setupShowMoreSwatches();
  applyVariantBadgeStyles();
});


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// Rebuild variants options when an variant is selected
const variantSelects = document.querySelector('variant-selects') || document.querySelector('variant-radios');
  if (variantSelects) {
    // Find all option containers (fieldset for radios, div for selects)
    const optionContainers = Array.from(
      variantSelects.querySelectorAll('.product-form__input--dropdown, fieldset')
    );

    // Parse product variants JSON
    const productJson = JSON.parse(
      variantSelects.querySelector('[type="application/json"]').textContent
    );

    let selectedOptions = [];
    variantSelects.addEventListener('change', rebuildOptions);
    rebuildOptions();

    function validCombo(inputValue, optionLevel) {
    for (let i = 0; i < productJson.length; i++) {
      if (optionLevel == 1) {
        if (
          productJson[i].option1 == selectedOptions[0] &&
          productJson[i].option2 == inputValue
        ) {
          return true;
        }
      } else {
        if (
          productJson[i].option1 == selectedOptions[0] &&
          productJson[i].option2 == selectedOptions[1] &&
          productJson[i].option3 == inputValue
        ) {
          return true;
        }
      }
    }
    return false;
  }

  function rebuildOptions() {
    // Collect selected values for each option
    selectedOptions = optionContainers.map((container) => {
      // Radios (swatches)
      const radios = container.querySelectorAll('input[type="radio"]');
      if (radios.length) {
        const checked = Array.from(radios).find((radio) => radio.checked);
        return checked ? checked.value : '';
      }
      // Selects
      const select = container.querySelector('select');
      if (select) {
        return select.value;
      }
      return '';
    });

    for (let optionLevel = 1, n = optionContainers.length; optionLevel < n; optionLevel++) {
      const container = optionContainers[optionLevel];
      const radios = container.querySelectorAll('input[type="radio"]');
      const selects = container.querySelectorAll('option');

      if (radios.length) {
        radios.forEach((input) => {
          input.disabled = !validCombo(input.value, optionLevel);
          const label = container.querySelector(`label[for="${input.id}"]`);
          if (label) {
            label.style.display = input.disabled ? 'none' : '';
          }
        });
      } else if (selects.length) {
        selects.forEach((input) => {
          input.hidden = !validCombo(input.value, optionLevel);
        });
      }
    }

    for (
      let optionLevel = 1, fieldsetsLength = optionContainers.length, change = false;
      optionLevel < fieldsetsLength && !change;
      optionLevel++
    ) {
      const container = optionContainers[optionLevel];
      const radios = container.querySelectorAll('input[type="radio"]');
      const selects = container.querySelectorAll('select');

      if (radios.length) {
        const checked = container.querySelector('input:checked');
        if (checked && checked.disabled === true) {
          const firstEnabled = container.querySelector('input:not(:disabled)');
          if (firstEnabled) {
            firstEnabled.checked = true;
            change = true;
          }
        }
      } else if (selects.length) {
        const select = selects[0];
        if (select && select.selectedOptions[0].hidden === true) {
          const firstEnabled = Array.from(select.options).find((opt) => !opt.hidden);
          if (firstEnabled) {
            firstEnabled.selected = true;
            change = true;
          }
        }
      }
      if (change) variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
    }
        // Ensure color name is updated after options are rebuilt
    updateSelectedColorNames();
  }
}